import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('@/views/DashboardLayout.vue'),
      children: [
        { path: '', redirect: { name: 'server-status' } },
        {
          path: 'server',
          name: 'server-status',
          component: () => import('@/views/ServerStatusView.vue'),
        },
        {
          path: 'sql',
          name: 'sql-console',
          component: () => import('@/views/SqlConsoleView.vue'),
        },
        {
          path: 'mysql-users',
          name: 'mysql-users',
          component: () => import('@/views/MysqlUsersView.vue'),
        },
        {
          path: 'account',
          name: 'account',
          component: () => import('@/views/AccountView.vue'),
        },
        {
          path: 'db/:db',
          name: 'database',
          component: () => import('@/views/DatabaseView.vue'),
          props: true,
        },
        {
          path: 'db/:db/:table',
          redirect: (to) => ({ name: 'table-browse', params: to.params }),
        },
        {
          path: 'db/:db/:table/browse',
          name: 'table-browse',
          component: () => import('@/views/TableBrowseView.vue'),
          props: true,
        },
        {
          path: 'db/:db/:table/structure',
          name: 'table-structure',
          component: () => import('@/views/TableStructureView.vue'),
          props: true,
        },
        {
          path: 'db/:db/:table/insert',
          name: 'table-insert',
          component: () => import('@/views/TableInsertView.vue'),
          props: true,
        },
      ],
    },
  ],
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.public) return true;
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  return true;
});

export default router;
